export { default } from './PageTitle';
